import {GPStorageFMG} from "./gp-storage-fmg.js";
import {FMGUpgrade} from './fmg-upgrade.js';
import $ from "jquery";
import {GPMisc} from "../gp-misc";
import {promoteExtraPlantPackage} from "../gp-plantpickerstore";

export let GPSettings = {
    
    appDescription: "FMG Online App",

    servicesAddr: "/fmg",
    servicesProtocol: "ajax",
    webSiteAddr: "",
    upgradeURL: "/plans/offer/",
    _language: null,
    
    customObjectsImgAddr: "/fmg/downloadCustomObject?p=",
    customObjectsThumbAddr: "/fmg/downloadCustomObject?p=",

    assetsMode:"remote",    
    assetsUseWebp: null, //detect based on browser

    defaultBackgroundId: 145,
    defaultTextureId:500,
    
    products: {
        basic_database : {active: true, fullname:"Basic free Plants & Structures database", package: 'basic'},
        premium_database : {active: false, fullname:"Extended Plants & Structures database", package: 'premium'},
        custom_background : {active: false, fullname:"Your custom image as a background"},
        four_seasons : {active: false, fullname:"Switch the view between 4 seasons of the year"},
        vegetables_database : {active: false, fullname:"Extra plant package - vegetables & herbs", package: 'vegetables'},
        extra_database : {active: false, fullname:"Extra 200 plants package", package: 'extra'}
    },

    storageClass: GPStorageFMG,
    upgradeClass: FMGUpgrade,
    
    thumbSaveWidth: 1600,
    maxAllowedWidth: 2048,
    maxAllowedStructureRenderingWidth: 1200,
    maxAllowedStructureRenderingHeight: 1200,

    initSettings: function() {
        let logErr = function (e) {
            let msg = encodeURIComponent(e.error ? e.error.stack : e.reason.stack);
            fetch(GPSettings.servicesAddr + "/logError?err="+msg).catch((e) => {});
            return false;
        }
        window.addEventListener("error", logErr);
        window.addEventListener("unhandledrejection", logErr);

        return new Promise(async (resolve) => {
            GPSettings.setupExitWarning();
            await GPSettings.checkGPComLogged();

            if (!GPSettings.storageClass.onlineAppEmail)
                document.location.href = "/";

            if (GPSettings.storageClass.onlineAppEmail)
                GPSettings.storageClass.loadCustomObjects();

            if (GPMisc.iOS()) {
                GPSettings.maxAllowedWidth = 800;
                GPSettings.maxAllowedStructureRenderingWidth = 400;
                GPSettings.maxAllowedStructureRenderingHeight = 400;
            }

            resolve();
        })
    },

    initLanguage: function() {
        let searchParams = new URLSearchParams(window.location.search)
        let lang = searchParams.has("lang") ? searchParams.get("lang"): "en";
        GPSettings._language = lang;

        $('html').attr('lang',lang);

        if (lang === "pl") {
            GPSettings.assetsAddr = "/static/assets/apigetdata-pl.json?v=__VERSION__";
        }
        if (lang === "en") {
            GPSettings.assetsAddr = "/static/assets/apigetdata-en.json?v=__VERSION__";
        }
    },

    language: function() {
        if (!GPSettings._language) GPSettings.initLanguage();
        return GPSettings._language;
    },

    plantsAddr: function() {
        return "/static/assets/plants/";
    },
    structuresAddr: function() { 
        return "/static/assets/equipment/";
    },
    texturesAddr: function() {
        return "/static/assets/textures/";
    },
    backgroundsAddr: function() {
        return "/static/assets/backgrounds/";
    },

    customObjectGetPathForImage: function(itemData) {
        return GPSettings.customObjectsImgAddr + itemData['id']+'.png';
    },

    customObjectGetPathForThumb: function(itemData) {
        return GPSettings.customObjectsThumbAddr + itemData['id']+'_t.png';
    },
    
    checkGPComLogged: function() {
        return new Promise((resolve) => {
            $.ajax({
                dataType: "json",
                params: {},
                url: GPSettings.webSiteAddr + "/api/apiusertoken",
                success: function(res) {GPSettings.processToken(res); resolve()}
              });
        })
    },

    processToken: function (res) {
        if (res['logged']) {
            if (res['hasPremium']) {
                GPSettings.products.premium_database.active = true;
                GPSettings.products.custom_background.active = true;
                GPSettings.products.four_seasons.active = true;
                GPSettings.products.vegetables_database.active = $.inArray("PAO_VD",res['userPackages'])>-1;
                GPSettings.products.extra_database.active = $.inArray("PAO_EXT",res['userPackages'])>-1;
            }
            GPSettings.storageClass.onlineAppEmail = res['email'];
            GPSettings.storageClass.token = res['token'];
            if (res['signupDate']) {
                let dateStr = res['signupDate'];
                GPSettings.storageClass.signupDate = Date.parse(dateStr);
            }
        }

        if (GPSettings.products.premium_database.active && !GPSettings.products.extra_database.active)
            promoteExtraPlantPackage.set(true);
    },
        
    setupExitWarning : function () {
        $(window).bind('beforeunload', function(e){
            if (GP.project && GP.project.unsavedChanges)
                return "There are some unsaved changes in your project."; 
            else
                e=null;
        });        
    },    
    
    extraDebugInfo: function () {
        return "\nHTML Version: " + GP.version;
    },

    gotoUpgradeWebsite: function() {
        window.open(GPSettings.upgradeURL, '_blank').focus();
    }

};

GPSettings.initLanguage();
window.GPSettings = GPSettings;